<template>
    <div class="goods_line_bottom">
        <div class="tabs_content">
            <ul>
                <li class="active">商品促销</li>
                <li @click="promotionjump">满减满送</li>
            </ul>
        </div>
        <GoodsList :type="type"></GoodsList>
    </div>
</template>

<script>
import GoodsList from '@/components/views/promotion/goodslist.vue'
export default {
    components: {GoodsList},
    data() {
        return {
            type: 0, // 0 商品促销 1 最近购买的商品
        }
    },
    methods: {
        promotionjump () { // 分页跳转
            this.$router.push({
                path: '/FullReduceSend'
            })
        },
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/views/promotion/promotion.vue